<template>
	<footer class="job-listing--item-footer">
		<a v-if="hasMatches && isPublished" href="#" class="matches" @click.prevent="$emit('load')">
			<Icon icon="heart" color="primary"/> {{ matches }}
		</a>
		<span v-else class="matches">
			<Icon icon="heart"/> {{ matches }}
		</span>
		<a
			v-if="isQuestionnaireFinished"
			href="#"
			:class="['status', {'published': isPublished}]"
			@click.prevent="clickedPublishInfo"
		>
			<Icon :icon="isPublished ? 'checkmark' : 'close'"/>
			{{ isPublished ? 'Anonym veröffentlicht' : 'Noch nicht veröffentlicht' }}
		</a>
		<PublishPopUp
			v-if="publish"
			:job-profile="jobProfileListItem.jobProfile"
			:publishable-checklist="jobProfileListItem.publishableChecklist"
			@hidden="publish = false"
			@publish="onPublish"
		/>
		<UnpublishPopUp
			v-if="unpublish"
			:job-profile="jobProfileListItem.jobProfile"
			@hidden="unpublish = false"
			@unpublish="onUnpublish"
		/>
	</footer>
</template>

<script>
import Icon from "@/vue/icon/Icon";
import PublishPopUp from "@/vue/job-profile/PublishPopUp.vue";
import UnpublishPopUp from "@/vue/job-profile/UnpublishPopUp.vue";

export default {

	components: {
		Icon,
		PublishPopUp,
		UnpublishPopUp
	},

	props: {
		jobProfileListItem: {
			type: Object,
			required: true,
		}
	},

	data ()
	{
		return {
			isPublished: this.jobProfileListItem.jobProfile.status.published,
			publish: false,
			unpublish: false,
		};
	},

	computed: {
		isQuestionnaireFinished ()
		{
			return this.jobProfileListItem.questionnaireFinished;
		},
		jobProfile ()
		{
			return this.jobProfileListItem.jobProfile;
		},
		hasMatches ()
		{
			return this.jobProfileListItem.matches > 0;
		},
		matches ()
		{
			return this.jobProfileListItem.matches + ' ' + (this.jobProfileListItem.matches === 1 ? 'Match' : 'Matches');
		},
	},

	methods: {
		showPublishPopUp ()
		{
			this.publish = true;
		},
		clickedPublishInfo ()
		{
			if (!this.isPublished)
			{
				this.publish = true;
				return;
			}

			this.unpublish = true;
		},
		onPublish ()
		{
			this.publish = false;
			this.isPublished = true;

			this.$emit('publish');
		},
		onUnpublish ()
		{
			this.unpublish = false;
			this.isPublished = false;

			this.$emit('unpublish');
		},
	}
}
</script>
